import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import InfoPage from ".";

const POSTAWAY_INTRO_VIDEO_URL =
  process.env.REACT_APP_POSTAWAY_INTRO_VIDEO_URL ||
  'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/jamie_01.mp4';

const text = "Postaway is the premier online travel platform exclusively for travel collaborations between creators and vacation rental hosts, hotels, and tourism boards. Postaway is redefining influencer travel by giving every creator the chance to experience incredible destinations, and every host the tools to amplify their reach through authentic content.";
const text2 = "Postaway is not just for travel collaborations, however. Travelers will also benefit from gaining access to itineraries and group trips from top travel creators, booking directly with hosts (saving fees), and discovering boutique hotels and coveted destinations around the globe.";

const WhatIsPostaway = () => {
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);

  const closeVideo = () => {
    setShowVideo(false);
    if (videoRef.current) videoRef.current.pause();
  };

  const below = (
    <div style={{ gridColumn: '1 / -1', textAlign: 'center', maxWidth: 760, margin: '0 auto' }}>
      <p style={{ margin: 0 }}>{text}</p>
      <br />
      <p>{text2}</p>
    </div>
  );
  const captionStyle = { fontFamily: "'Neue Einstellung', 'Poppins', sans-serif", fontSize: 'clamp(10px, 3vw, 12px)', color: '#0f084b', opacity: .9, lineHeight: 1.35, textAlign: 'center', marginTop: 6 };
  const itemStyle = { display: 'grid', justifyItems: 'center' };
  const imgStyle = { width: 'clamp(120px, 28vw, 220px)', height: 'clamp(120px, 28vw, 220px)', objectFit: 'cover', borderRadius: '4px' };
  const belowHeader = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '28px' }}>
      <button
        type="button"
        onClick={() => setShowVideo(true)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 10,
          padding: '14px 32px', border: 'none', borderRadius: 8,
          background: '#0f084b', color: '#fff',
          fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
          fontSize: 15, fontWeight: 700, letterSpacing: '0.02em',
          cursor: 'pointer', boxShadow: '0 4px 16px rgba(15, 8, 75, 0.18)',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
          <polygon points="5,3 19,12 5,21" fill="currentColor" />
        </svg>
        Watch: What is Postaway
      </button>
      <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <div style={itemStyle}>
          <img className="stampImg" src="/images/content/what-1.jpeg" alt="What 1" style={imgStyle} />
          <div style={captionStyle}>@adventuringeyes x @chestnuthillcabin</div>
        </div>
        <div style={itemStyle}>
          <img className="stampImg" src="/images/content/what-2.jpeg" alt="What 2" style={imgStyle} />
          <div style={captionStyle}>@workfromdenver x @chestnuthillcabin</div>
        </div>
        <div style={itemStyle}>
          <img className="stampImg" src="/images/content/what-3.jpeg" alt="What 3" style={imgStyle} />
          <div style={captionStyle}>@chelsea.schillizzi x @southernpinescabin</div>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <InfoPage title="What is Postaway" belowHeader={belowHeader} below={below} belowTitleCenter tallOverride={false} />
      {showVideo && createPortal(
        <div
          onClick={closeVideo}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 99999, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative', maxWidth: 400, maxHeight: '90vh',
              background: '#111', borderRadius: 16, overflow: 'hidden',
              boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
            }}
          >
            <button
              onClick={closeVideo}
              aria-label="Close video"
              style={{
                position: 'absolute', top: 12, right: 12, width: 36, height: 36,
                borderRadius: '50%', background: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(8px)', border: 'none', color: '#fff',
                cursor: 'pointer', display: 'flex', alignItems: 'center',
                justifyContent: 'center', zIndex: 2,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
            <video
              ref={videoRef}
              src={POSTAWAY_INTRO_VIDEO_URL}
              style={{ width: '100%', display: 'block', borderRadius: 16, maxHeight: '85vh', objectFit: 'contain', background: '#000' }}
              playsInline
              controls
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default WhatIsPostaway;


